module.exports = __webpack_public_path__ + "img/600.2895ba36.svg";